import { render, staticRenderFns } from "./onlineStay.vue?vue&type=template&id=b35832ac&"
import script from "./onlineStay.vue?vue&type=script&lang=js&"
export * from "./onlineStay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b35832ac')) {
      api.createRecord('b35832ac', component.options)
    } else {
      api.reload('b35832ac', component.options)
    }
    module.hot.accept("./onlineStay.vue?vue&type=template&id=b35832ac&", function () {
      api.rerender('b35832ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/onlineStay.vue"
export default component.exports